var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalPoValueCopy2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Total PO Value Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total-PO-Value-Copy-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#E6F5F9",
    cx: 21,
    cy: 21,
    r: 21
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(11.000000, 13.000000)",
    fill: "#2CACCF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6 L19.00002,6 C19.55232,6 20.00002,6.44772 20.00002,7 L20.00002,17 C20.00002,17.5523 19.55232,18 19.00002,18 L1,18 C0.44772,18 0,17.5523 0,17 L0,6 Z M1,0 L16.00002,0 L16.00002,4 L0,4 L0,1 C0,0.44772 0.44772,0 1,0 Z M13.00002,11 L13.00002,13 L16.00002,13 L16.00002,11 L13.00002,11 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPoValueCopy2);
export default __webpack_public_path__ + "static/media/Total PO Value Copy 2.622f8b7620f2d66e97534a4615c8f888.svg";
export { ForwardRef as ReactComponent };